<template>
  <section class="the-trial-of-foils-wrap" v-parallax>
    <v-page :background="theme.colors.cyan" v-slide-up-in>
      <v-sub-chapter-index-page
        :pageData="pageDataItem.page0.data"
        v-slide-up-in-stage="1"
      />
    </v-page>

    <v-page>
      <v-text-content
        :isGodsWord="true"
        :html="pageDataItem.page1.data.content"
      />
    </v-page>

    <v-page link-above>
      <v-full-screen-paint
        paintPath="images/six-trials-of-God-s-judgment-work/the-trial-of-foils/page2ImageViewer.jpg"
        :fullScreenPaintData="pageDataItem.page2.data"
      />
    </v-page>

    <v-page>
      <v-text-content
        :isGodsWord="true"
        :html="pageDataItem.page3.data.content"
      />
    </v-page>

    <v-page :background="theme.colors.cyan">
      <v-float-image-content :data="pageDataItem.page4.data.content" />
    </v-page>

    <v-page link-above>
      <v-full-screen-paint
        paintPath="images/six-trials-of-God-s-judgment-work/the-trial-of-foils/page5ImageViewer.jpg"
        :fullScreenPaintData="pageDataItem.page5.data"
      />
    </v-page>

    <v-page>
      <v-text-content
        :isGodsWord="true"
        :html="pageDataItem.page6.data.content"
      />
    </v-page>

    <v-page :background="theme.colors.cyan">
      <v-float-image-content :data="pageDataItem.page7.data.content" />
    </v-page>

    <v-page>
      <v-text-content
        :isGodsWord="true"
        :html="pageDataItem.page8.data.content"
      />
    </v-page>

    <v-page :background="theme.colors.cyan">
      <v-text-content :html="pageDataItem.page9.data.content" />
    </v-page>

    <v-page link-above>
      <v-full-screen-paint
        paintPath="images/six-trials-of-God-s-judgment-work/the-trial-of-foils/page8ImageViewer.jpg"
        :fullScreenPaintData="pageDataItem.page10.data"
      />
    </v-page>

    <v-page :background="theme.colors.cyan">
      <v-full-screen-songs-player
        :data="pageDataItem.page11.data"
        bg="images/common/hymnsPosters/six-trials-of-God-s-judgment-work-4.jpg"
      />
    </v-page>

    <v-page :background="theme.colors.cyan">
      <v-chatper-entry bg-color="cyan" />
    </v-page>
  </section>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("global", ["schema"]),
  },
  data() {
    return {
      pageDataItem: {},
    };
  },
  created() {
    this.pageDataItem = this.schema["the-trial-of-foils"].item;
  },
};
</script>
